import React, { useEffect, useState } from 'react';
import { Card } from 'antd';
import { EyeOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { listPromotions } from "../function/promotion";
import { useNavigate } from 'react-router-dom';
import './Product.css';

const { Meta } = Card;

const ProductCardEmployee = ({ product }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state);  // ดึงข้อมูล user จาก Redux
  const [isHovered, setIsHovered] = useState(false);
  const [hasPromotion, setHasPromotion] = useState(false);

  const { _id, title, description, images, price, sold } = product;

  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const res = await listPromotions();
        const promotions = res.data;
        const productPromotion = promotions.find(promotion =>
          promotion.products.some(p => p._id === product._id)
        );

        if (productPromotion) {
          setHasPromotion(true);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchPromotions();
  }, [product]);

  const handleAddToCart = (event) => {
    event.stopPropagation();
    let cart = [];
    if (localStorage.getItem('cart')) {
      cart = JSON.parse(localStorage.getItem('cart'));
    }
    cart.push({
      ...product,
      count: 1
    });

    let unique = _.uniqWith(cart, _.isEqual);
    localStorage.setItem('cart', JSON.stringify(unique));
    dispatch({
      type: 'ADD_TO_CART',
      payload: unique
    });
    dispatch({
      type: 'SET_VISIBLE',
      payload: true
    });
  };

  const cleanedDescription = description.replace(/<[^>]*>/g, ''); 
  const shortenedDescription = cleanedDescription.slice(0, 24) + "...";

  const handleCardClick = () => {
    navigate(`/product/${_id}`);
  };

  const finalPrice = user && user.role === "employee" ? price * 0.9 : price;

  const formattedPrice = new Intl.NumberFormat('th-TH', {
    style: 'currency',
    currency: 'THB',
  }).format(finalPrice);

  return (
    <div className='shop-card-container'>
      {hasPromotion && (
        <div className='promotion-label'>Promotion</div>
      )}
      <Card
        hoverable
        className='shop-card mx-auto'
        cover={
          <img
            className='p-1 product-image'
            alt='example'
            src={images && images.length ? images[0].url : ''}
          />
        }
        style={{
          boxShadow: isHovered ? '0 4px 8px rgba(150, 27, 78, 0.7)' : '0 4px 8px rgba(0, 0, 0, 0.1)',
          transition: 'box-shadow 0.3s ease-in-out'
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleCardClick}
      >
        <Meta title={title} description={shortenedDescription} />
        <div className="shop-price">
          <h4>
            {hasPromotion ? <del>{formattedPrice}</del> : formattedPrice}
          </h4>
        </div>
      </Card>
    </div>
  );
};

export default ProductCardEmployee;